import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, share } from 'rxjs/operators';
import { GetAppConfigResponse, GetAppConfigResponseInterface } from './product-settings.model';
import { Environment, EnvironmentService } from '@galaxy/core';

@Injectable()
export class ProductSettingsService {
  private _host: string;

  constructor(private environmentService: EnvironmentService, private http: HttpClient) {}

  host(): string {
    if (this._host) {
      return this._host;
    }

    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        this._host = 'wsp-admin-center-api.vendasta-local.com';
        break;
      case Environment.TEST:
        this._host = '';
        break;
      case Environment.DEMO:
        this._host = 'websitepro-demo.apigateway.co';
        break;
      case Environment.PROD:
        this._host = 'websitepro-prod.apigateway.co';
        break;
    }
    return this._host;
  }

  hostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.host();
  }

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }

  getAppConfig(partnerId: string): Observable<GetAppConfigResponse> {
    return this.http
      .post<GetAppConfigResponseInterface>(
        this.hostWithScheme() + '/wsp_admin_center.v1.AdminCenterService/GetAppConfig',
        { partnerId: partnerId },
        this.apiOptions(),
      )
      .pipe(
        map((resp) => GetAppConfigResponse.fromProto(resp)),
        share(),
      );
  }
}
